document.addEventListener("DOMContentLoaded", function () {
	var bar = document.createElement("div");
	bar.className = "pk-scroll-indicator";
	bar.setAttribute("aria-hidden", "true");

	var fill = document.createElement("div");
	fill.className = "pk-scroll-indicator-fill";
	bar.appendChild(fill);

	document.body.appendChild(bar);

	// CSS scroll-driven animation handles progress where supported (Chrome/Edge/Firefox).
	// Bail out of JS updates there; only Safari (no animation-timeline) needs the fallback below.
	if (
		window.CSS &&
		CSS.supports &&
		CSS.supports("animation-timeline: scroll()")
	) {
		return;
	}

	function update() {
		var scrollable =
			document.documentElement.scrollHeight - window.innerHeight;
		var progress = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 0;
		fill.style.width = Math.min(100, Math.max(0, progress)) + "%";
	}

	window.addEventListener("scroll", update, { passive: true });
	window.addEventListener("resize", update);
	update();
});
